// Mock data for Axios Development landing page

export const services = [
    {
        id: 1,
        title: "Custom Website Development",
        description: "Bespoke websites tailored to your brand identity and business goals. From corporate sites to complex web applications.",
        features: ["Responsive Design", "SEO Optimized", "Fast Performance", "Custom CMS"]
    },
    {
        id: 2,
        title: "E-Commerce Solutions",
        description: "Powerful online stores that convert visitors into customers. Complete with payment integration and inventory management.",
        features: ["Secure Payments", "Product Management", "Analytics Dashboard", "Mobile Optimized"]
    },
    {
        id: 3,
        title: "Mobile App Development",
        description: "Native and cross-platform mobile applications that deliver seamless user experiences on iOS and Android.",
        features: ["iOS & Android", "Cloud Integration", "Push Notifications", "Offline Support"]
    },
    {
        id: 4,
        title: "Online Ordering Systems",
        description: "Streamlined ordering platforms for restaurants, retail, and service businesses. Real-time order management.",
        features: ["Real-time Updates", "Payment Processing", "Order Tracking", "Customer Portal"]
    },
    {
        id: 5,
        title: "Blog & Content Platforms",
        description: "Engaging content management systems designed for publishers, bloggers, and content creators.",
        features: ["Easy Publishing", "SEO Tools", "Social Integration", "Analytics"]
    },
    {
        id: 6,
        title: "UI/UX Design",
        description: "Beautiful, intuitive interfaces that prioritize user experience and drive engagement across all devices.",
        features: ["User Research", "Prototyping", "Design Systems", "Usability Testing"]
    }
];

export const portfolioProjects = [
    {
        id: 1,
        title: "Premium Fashion E-Commerce",
        category: "E-Commerce",
        description: "A luxury fashion brand's complete online store with custom product configurator and AR try-on features.",
        tags: ["E-Commerce", "React", "Node.js", "AR Integration"]
    },
    {
        id: 2,
        title: "Restaurant Ordering Platform",
        category: "Online Ordering",
        description: "Multi-location restaurant chain with real-time ordering, kitchen display system, and delivery tracking.",
        tags: ["Ordering System", "Real-time", "Mobile App", "Admin Dashboard"]
    },
    {
        id: 3,
        title: "FinTech Mobile App",
        category: "Mobile App",
        description: "Cross-platform banking application with biometric authentication and real-time transaction monitoring.",
        tags: ["iOS", "Android", "Security", "Cloud Integration"]
    },
    {
        id: 4,
        title: "Content Publishing Platform",
        category: "Blog/CMS",
        description: "Modern publishing platform for digital magazine with subscription management and multimedia content.",
        tags: ["CMS", "Publishing", "Subscriptions", "SEO"]
    },
    {
        id: 5,
        title: "Corporate Website Redesign",
        category: "Website",
        description: "Complete digital transformation for a B2B enterprise, including CMS and client portal integration.",
        tags: ["Enterprise", "B2B", "CMS", "Portal"]
    },
    {
        id: 6,
        title: "Health & Wellness App",
        category: "Mobile App",
        description: "Fitness tracking and wellness coaching platform with AI-powered recommendations and social features.",
        tags: ["Mobile", "AI", "Health Tech", "Social"]
    }
];

export const testimonials = [
    {
        id: 1,
        name: "Sarah Mitchell",
        company: "Luxe Fashion Co.",
        role: "CEO",
        text: "They transformed our vision into a stunning e-commerce platform that exceeded all expectations. Sales increased 300% in the first quarter.",
        rating: 5
    },
    {
        id: 2,
        name: "James Rodriguez",
        company: "Foodie's Paradise",
        role: "Owner",
        text: "The online ordering system they built has revolutionized our business. Our customers love the seamless experience and we've expanded to 5 new locations.",
        rating: 5
    },
    {
        id: 3,
        name: "Emily Chen",
        company: "TechStart Ventures",
        role: "Product Director",
        text: "Exceptional work on our mobile app. The team's attention to detail and commitment to quality is unmatched. Highly recommend for any serious project.",
        rating: 5
    },
    {
        id: 4,
        name: "Michael Brown",
        company: "Digital Insights Magazine",
        role: "Editor-in-Chief",
        text: "Our new content platform is a game-changer. Intuitive, fast, and our readers engagement has doubled. Best investment we've made.",
        rating: 5
    }
];

export const stats = [
    { label: "Projects Completed", value: "500+" },
    { label: "Happy Clients", value: "300+" },
    { label: "Years Experience", value: "10+" },
    { label: "Team Members", value: "50+" }
];
